module.exports = __webpack_public_path__ + "img/pdf_gris.6ef38879.png";